import { useUtils } from "@/app/hooks/useUtils";
import { Dialog, Transition } from "@headlessui/react";
import React, { Fragment, useRef } from "react";
type Props = {
  open: boolean;
  setOpen: (value: boolean) => void;
  serviceDetails?: any;
  setServiceDetails?: (e: any) => void;
};

const RemarksComponent: React.FC<Props> = ({ open, setOpen, serviceDetails, setServiceDetails }) => {
  const cancelButtonRef = useRef(null);

  const { extractTextArray } = useUtils(); // use inside the component

  return (
    <div>
      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-50 overflow-y-auto"
          initialFocus={cancelButtonRef}
          onClose={() => {
            setOpen(false);
          }}
        >
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" />
            </Transition.Child>

            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
              &#8203;
            </span>

            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div className="inline-block align-bottom bg-white rounded-2xl text-left  overflow-visible  shadow-xl transform transition-all sm:my-8 sm:align-middle sm:w-full sm:max-w-3xl">
                <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4 rounded-2xl">
                  <div className="flex justify-between items-center mt-2">
                    {/* <XMarkIcon className="w-5 h-5 cursor-pointer" onClick={() => setOpen(false)} /> */}
                  </div>
                
                
                  {serviceDetails?.latest_public_comment && (
                    <div>
                      <h2 className="font-semibold text-sm">Public Comments :</h2>

                      <p className="text-xs leading-6">{extractTextArray(serviceDetails?.latest_public_comment)}</p>
                    </div>
                  )}
                  {serviceDetails?.latest_private_comment && (
                    <div>
                      <h2 className="font-semibold pt-2 text-sm ">Private Comments :</h2>

                      <p className="text-xs leading-6">{extractTextArray(serviceDetails?.latest_private_comment)}</p>
                    </div>
                  )}

                  <div className="flex justify-end gap-4 mt-6">
                    <button
                      className="rounded-md bg-[#193A6A] font-bold px-10 py-2 text-sm text-white "
                      onClick={() => {
                        setOpen(false);
                        setServiceDetails(null);
                      }}
                    >
                      Ok
                    </button>
                  </div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
};

export default RemarksComponent;
